import { apiFetch } from '../../lib/api';

export type Zustimmung = 'offen' | 'zugestimmt' | 'abgelehnt';
export type Zahlung    = 'offen' | 'bezahlt' | 'befreit';

export interface AusflugTeilnehmer {
  id: number;
  termin_id: number;
  schueler_id: number;
  vorname: string;
  nachname: string;
  zustimmung: Zustimmung;
  zahlung: Zahlung;
  notiz: string | null;
  mahnung_anzahl: number;
  letzte_mahnung_am: string | null;
  anwesend: 0 | 1 | null;
  anwesend_erfasst_am: string | null;
  fehlzeit_id: number | null;
}

export interface AusflugTermin {
  id: number;
  titel: string;
  datum: string;
  datum_ende: string | null;
  klasse_id: number | null;
  klasse_name: string | null;
  ausflug_kosten: number | null;
  ausflug_zahlung_bis: string | null;
  abgeschlossen_am?: string | null;   // Welle U5
}

export interface AusflugStats {
  gesamt: number;
  zugestimmt: number; abgelehnt: number; offen_zustimmung: number;
  bezahlt: number; befreit: number; offen_zahlung: number;
  anwesend: number; fehlt: number; anwesend_erfasst: number;
}

export interface AusflugDetailResponse {
  termin: AusflugTermin;
  teilnehmer: AusflugTeilnehmer[];
  stats: AusflugStats;
}

export interface MahnungEmpfaenger {
  schueler_id: number;
  schueler_name: string;
  eltern_hauptkontakte: { name: string | null; email: string }[];
}
export interface MahnungAusgenommen {
  schueler_id: number;
  schueler_name: string;
  grund: 'abgelehnt' | 'sensible_woerter' | 'notiz_vorhanden' | 'mahnung_max';
}
export interface MahnungDraft {
  schueler_id: number;
  schueler_name: string;
  empfaenger: string[];
  betreff: string;
  mail_text: string;
}

// Welle S4b: lokaler Fetch-Klon entfernt — zentraler apiFetch aus lib/api
export const ausflugApi = {
  laden: (terminId: number) =>
    apiFetch<AusflugDetailResponse>(`/api/ausfluege/${terminId}`),

  aktiv: () =>
    apiFetch<{ aktive_ausfluege: { termin_id: number; titel: string; datum: string; klasse_name: string | null; ausflug_kosten: number | null; stats: AusflugStats }[] }>(
      '/api/ausfluege/aktiv'
    ),

  klassen: () =>
    apiFetch<{ klasse_id: number; klasse_name: string }[]>('/api/meine-klassen/unique'),

  schueler: () =>
    apiFetch<{ id: number; vorname: string; nachname: string; klasse_id: number }[]>('/api/schueler'),

  bulkAddTeilnehmer: (terminId: number, schuelerIds: number[], klasseId?: number) =>
    apiFetch<{ hinzugefuegt_count: number; bereits_vorhanden_count: number; klasse_id: number }>(
      `/api/ausfluege/${terminId}/teilnehmer/bulk-add`,
      { method: 'POST', body: JSON.stringify({ schueler_ids: schuelerIds, ...(klasseId != null ? { klasse_id: klasseId } : {}) }) }
    ),

  patchTeilnehmer: (terminId: number, schuelerId: number, patch: {
    zustimmung?: Zustimmung; zahlung?: Zahlung; notiz?: string | null; anwesend?: 0 | 1 | null;
    bestaetigt_vorjahr?: boolean;   // Welle U5: rückwirkende Fehlzeit (voriges SJ) bestätigt
  }) =>
    apiFetch<{ teilnehmer: AusflugTeilnehmer; fehlzeit_id: number | null }>(
      `/api/ausfluege/${terminId}/teilnehmer/${schuelerId}`,
      { method: 'PATCH', body: JSON.stringify(patch) }
    ),

  // Welle U6a
  entferneTeilnehmer: (terminId: number, schuelerId: number) =>
    apiFetch<{ erfolg: boolean }>(`/api/ausfluege/${terminId}/teilnehmer/${schuelerId}`, { method: 'DELETE' }),

  // Welle U5
  abschliessen: (terminId: number) =>
    apiFetch<{ termin: AusflugTermin }>(`/api/ausfluege/${terminId}/abschliessen`, { method: 'POST' }),
  oeffnen: (terminId: number) =>
    apiFetch<{ termin: AusflugTermin }>(`/api/ausfluege/${terminId}/oeffnen`, { method: 'POST' }),
  loeschen: (terminId: number) =>
    apiFetch<{ erfolg: boolean }>(`/api/schultermine/${terminId}`, { method: 'DELETE' }),

  mahnungPreview: (terminId: number, typ: 'zustimmung' | 'zahlung') =>
    apiFetch<{ empfaenger_inkludiert: MahnungEmpfaenger[]; ausgenommen: MahnungAusgenommen[]; vorschau: { schueler_name: string; betreff: string; body: string } | null }>(
      `/api/ausfluege/${terminId}/mahnung/preview`,
      { method: 'POST', body: JSON.stringify({ typ }) }
    ),

  mahnungBulk: (terminId: number, typ: 'zustimmung' | 'zahlung', schuelerIds: number[]) =>
    apiFetch<{ gesendet_count: number; drafts_zum_kopieren: MahnungDraft[] }>(
      `/api/ausfluege/${terminId}/mahnung/bulk`,
      { method: 'POST', body: JSON.stringify({ typ, schueler_ids: schuelerIds }) }
    ),
};
